export default __webpack_public_path__ + "static/desktop-abdbdb528a7ca77906f81e0fba6efb0d.jpg";